module.exports = __webpack_public_path__ + "static/media/supper.f642b163.jpeg";